export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    id: 'faq-1',
    question: '萌白酱的B站频道叫什么？',
    answer: '萌白酱的B站官方频道名为"萌白酱Official"，UID为123456789。在B站搜索"萌白酱"即可找到并关注，获取最新视频更新和直播通知。',
  },
  {
    id: 'faq-2',
    question: '如何加入萌白酱官方粉丝社群？',
    answer: '可以通过以下方式加入：1）B站充电专属粉丝群（月度充电即可加入）；2）QQ官方粉丝群（群号见B站动态公告）；3）Discord国际粉丝服务器（链接见B站简介）。所有社群均有管理员维护，请遵守社群规范。',
  },
  {
    id: 'faq-3',
    question: '萌白酱的周边产品在哪里购买？',
    answer: '萌白酱官方周边产品可通过以下渠道购买：1）B站会员购（搜索"萌白酱"）；2）淘宝官方店铺"萌白酱的小店"；3）线下漫展活动现场购买。请认准官方渠道，谨防假冒伪劣产品。',
  },
  {
    id: 'faq-4',
    question: '萌白酱的最新视频什么时候更新？',
    answer: '萌白酱保持稳定的更新频率：B站主频道每周三、周六晚8点更新；抖音和快手每日更新短视频内容；特别企划和联动视频会提前在动态中预告。具体更新安排可能随拍摄进度调整，请关注B站动态获取最新通知。',
  },
  {
    id: 'faq-5',
    question: '萌白酱会参加哪些线下活动？',
    answer: '萌白酱定期参加国内各大漫展和同人展活动。具体行程会提前1-2个月在B站动态和粉丝社群中公布。主要参与的活动包括：ChinaJoy、萤火虫动漫嘉年华、CD同人展、国风动漫节等。现场提供周边签售和粉丝互动环节。',
  },
  {
    id: 'faq-6',
    question: '如何联系萌白酱进行商务合作？',
    answer: '商务合作请发送邮件至：mengbaijiang@example.com，邮件中请注明合作方信息、合作方案和预期效果。萌白酱团队将在5个工作日内回复。目前接受品牌代言、联名合作、活动出席等商业合作形式。',
  },
  {
    id: 'faq-7',
    question: '萌白酱的原创歌曲什么时候发布？',
    answer: '萌白酱首支个人原创单曲正在制作中，预计2026年12月在各大音乐平台同步上线。歌曲融合J-Pop与电子元素，歌词由萌白酱亲自参与创作。B站将提前一周发布MV预告片，敬请关注！',
  },
  {
    id: 'faq-8',
    question: '萌白酱会做游戏直播吗？',
    answer: '会的！萌白酱不定期在B站进行游戏直播，主要直播内容包括《原神》《崩坏：星穹铁道》《Minecraft》等人气游戏。直播时间会提前在B站动态中预告，关注萌白酱B站账号即可收到开播提醒。',
  },
];

export const getFAQItems = (): FAQItem[] => faqItems;